// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"e9f9948f","280":"0a206944","294":"7c9bd5cb","497":"11fc5a48"}[chunkId] + ".chunk.css";
};